import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Theme } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";
import { Provider } from "react-redux";
import store from "./app/store.js";
import { ThemeProvider } from "next-themes";
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router>
      <ThemeProvider attribute="class" enableSystem>
        <Theme radius="full">
          <Provider store={store}>
            <App />
          </Provider>
        </Theme>
      </ThemeProvider>
    </Router>
  </React.StrictMode>
);
